<template>
  <div>
    <van-form ref="myForm" :disabled="formDisabled">
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.basic") }}</div>
        <!-- 上传照片 -->
        <div class="upload-photos">
          <div class="upload-photos-title">{{ $t("upload_photo.title") }}</div>
          <div class="upload-photo-box">
            <van-uploader
              v-model="fileList.photo"
              :max-count="1"
              class=""
              :after-read="uploadPhoto"
              @delete="deletePhoto"
              :disabled="formDisabled"
              :before-delete="() => !formDisabled"
              upload-icon=""
            />
            <div class="upload-photos-tips">
              <div class="upload-photos-tips-top request">
                {{ $t("upload_photo.avatar_str") }}
              </div>
              <div class="upload-photos-tips-content">
                {{ $t("upload_photo.avatar_tip1") }}<br />
                {{ $t("upload_photo.avatar_tip2") }}<br />
                {{ $t("upload_photo.avatar_tip3") }}<br />
                {{ $t("upload_photo.avatar_tip4") }}
              </div>
            </div>
          </div>
        </div>
        <template>
          <div
            class="item"
            v-for="(item, index) in basicInfo"
            :key="index"
            v-show="item.show ? item.show() : true"
            :class="!item.label ? 'no-label' : ''"
          >
            <van-field
              v-model="form[item.key]"
              :label="$t(item.label)"
              :right-icon="item.arrowIcon"
              :class="{
                'input-radio':
                  item.label === 'form.label.gender' ||
                  item.label === 'form.label.documentVal',
              }"
              :placeholder="$t(item.placeholder)"
              :readonly="item.arrowIcon === '' ? false : true"
              :clickable="item.arrowIcon === '' ? false : true"
              @click="
                item.arrowIcon === '' || formDisabled
                  ? ''
                  : openPop(item.key, index, 0)
              "
              v-if="
                item.key !== 'idValidityType' &&
                item.key !== 'idValidity' &&
                item.key !== 'idType' &&
                item.key !== 'idTypeOther'
              "
            >
              <template #input v-if="item.type === 'sel'">
                <input
                  type="text"
                  readonly="readonly"
                  :disabled="item.disabled || formDisabled"
                  :placeholder="$t3('请选择', 'Please select ...')"
                  class="van-field__control"
                  :value="dict[item.key][form[item.key]]"
                />
              </template>

              <template #input v-else-if="item.label === 'form.label.gender'">
                <div
                  class="radio"
                  :class="{
                    'radio-checked': dict.gender[form.gender] === item1,
                    disabled: item.disabled || formDisabled,
                  }"
                  v-for="item1 in gender"
                  :key="item1"
                  @click.stop="
                    item.disabled || formDisabled
                      ? ''
                      : (form.gender = {
                          男: '男',
                          女: '女',
                          保密: '保密',
                          male: '男',
                          female: '女',
                          secrecy: '保密',
                        }[item1])
                  "
                >
                  {{ item1 }}
                </div>
              </template>

              <template #label v-if="item.label === 'form.label.photo'"
                >{{ $t("form.label.photo")
                }}<img class="asterisk" :src="star" alt="" />
                <img
                  src="@/assets/img/infoIcon01.svg"
                  alt=""
                  @click="photo = true"
                />
              </template>
              <template #label v-else-if="item.rule"
                >{{ $t(item.label) }}<img class="asterisk" :src="star" alt=""
              /></template>
            </van-field>

            <div class="vant-input-row" v-else-if="item.key === 'idType'">
              <van-field
                v-model="form[item.key]"
                :label="$t(item.label)"
                class="left"
                right-icon="arrow-down"
                :clickable="true"
                @click="
                  item.disabled || formDisabled
                    ? ''
                    : openPop('idType', index)
                "
                :disabled="item.disabled || formDisabled"
              >
                <template #input>
                  <input
                    type="text"
                    readonly="readonly"
                    :disabled="item.disabled || formDisabled"
                    :placeholder="$t(item.placeholder)"
                    class="van-field__control"
                    :value="dict[item.key][form[item.key]]"
                  />
                </template>
                <template #label>
                  {{ $t(item.label) }}
                  <img class="asterisk" :src="star" alt="" v-if="item.rule" />
                </template>
              </van-field>
              <van-field
                v-model="form.idTypeOther"
                class="right"
                v-if="
                  dict.idType[form.idType] === '其他' ||
                  dict.idType[form.idType] === 'Other'
                "
                :disabled="item.disabled"
                :placeholder="$t('form.label.enter')"
              >
              </van-field>
            </div>
            <div
              class="vant-input-row idValidityType"
              v-else-if="item.key === 'idValidityType'"
            >
              <van-field
                v-model="form[item.key]"
                :label="$t(item.label)"
                class="left"
                right-icon="arrow-down"
                :clickable="true"
                @click="
                  item.disabled || formDisabled
                    ? ''
                    : openPop('idValidityType', index)
                "
                :disabled="item.disabled || formDisabled"
              >
                <template #input>
                  <input
                    type="text"
                    readonly="readonly"
                    :disabled="item.disabled || formDisabled"
                    :placeholder="$t(item.placeholder)"
                    class="van-field__control"
                    :value="dict[item.key][form[item.key]]"
                  />
                </template>
              </van-field>
              <van-field
                v-model="form.idValidity"
                class="right"
                right-icon="arrow-down"
                readonly="readonly"
                :clickable="true"
                @click="
                  item.disabled || formDisabled
                    ? ''
                    : openPop('idValidity', index + 1)
                "
                :placeholder="$t(item.placeholder)"
                v-if="form.idValidityType == 1"
                :disabled="item.disabled"
              >
              </van-field>
            </div>
          </div>
        </template>
      </div>
      <div class="line"></div>
      <div class="information-box">
        <div class="information-title">{{ $t("form.title.post") }}</div>
        <template>
          <div class="item" v-for="(item, index) in postInfo" :key="index">
            <van-field
              v-model="form[item.key]"
              :label="$t(item.label)"
              :right-icon="item.arrowIcon"
              :class="{
                'person-upload': item.label === 'form.label.uploadAtta',
              }"
              :placeholder="$t(item.placeholder)"
              :readonly="item.arrowIcon === '' ? false : true"
              :clickable="item.arrowIcon === '' ? false : true"
              :type="item.type ? item.type : 'text'"
              :rows="5"
              :maxlength="item.maxlength ? item.maxlength : 100"
              :show-word-limit="item.type === 'textarea'"
              @click="
                item.arrowIcon === '' || formDisabled
                  ? ''
                  : openPop(item.key, index, 1)
              "
            >
              <template #input v-if="item.type === 'sel'">
                <input
                  type="text"
                  readonly="readonly"
                  :disabled="item.disabled || formDisabled"
                  :placeholder="$t3('请选择', 'Please select ...')"
                  class="van-field__control"
                  :value="dict[item.key][form[item.key]]"
                />
              </template>
              <template #label v-if="item.rule"
                >{{ $t(item.label) }}<img class="asterisk" :src="star" alt=""
              /></template>
            </van-field>
          </div>
        </template>
      </div>
      <div class="line"></div>
      <!-- 联系信息 -->
      <div class="information-box">
        <div class="information-title">{{ $t('form.title.person') }}</div>
        <div class="item">
          <van-field v-model="form.phone" :label="$t('form.label.phone')" :placeholder="$t('form.label.enter')">
            <template #label>
              {{ $t('form.label.phone') }}<img class="asterisk" :src="star" alt="" />
            </template>
          </van-field>
        </div>
        <div class="item">
          <van-field v-model="form.email" :placeholder="$t('form.label.enter')">
            <template #label>
              <div class="person-mail">
                <span>{{ $t('form.label.mail') }}<img class="asterisk" :src="star" alt="" /></span>
                <!-- <p>{{ $t('form.label.initialPas') }}</p> -->
              </div>
            </template>
          </van-field>
        </div>
      </div>
    </van-form>
    <van-dialog
      v-model="photo"
      :title="$t('photoDia.title')"
      theme="round-button"
      :confirm-button-text="$t('gotIt')"
      class="notice-dialog"
    >
      <div class="notice-dialog-body">
        <div>{{ $t("photoDia.article1") }}</div>
        <div>{{ $t("photoDia.article2") }}</div>
        <div>{{ $t("photoDia.article3") }}</div>
        <div>{{ $t("photoDia.article4") }}</div>
      </div>
    </van-dialog>
    <!-- 选择框 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :default-index="form[nowKey]"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      >
        <template #option="item">
          {{ dict[nowKey][item] }}
        </template>
      </van-picker>
    </van-popup>
    <!-- 日期选择 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="$t3('选择年月日', 'Select date')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onTimeConfirm"
        @cancel="showTimePicker = false"
      />
    </van-popup>
    <!-- 疫苗选择 -->
    <van-popup v-model="showVaccinesPicker" position="bottom">
      <van-picker
        show-toolbar
        :default-index="form.vaccinated"
        :columns="vaccinated"
        @confirm="onVaccines"
        @cancel="showVaccinesPicker = false"
      >
        <template #option="item">
          {{ dict.vaccinated[item] }}
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { objectMergLeft, fixedNumber } from "@/utils";
import { getDictSelArr } from "@/api/dict";
import { getStatusObjTwo } from "@/utils/common-config";
import { toMedia } from "@/utils/request";
import { addFile } from "@/api/file";
import { mapGetters } from "vuex";

const tmpForm = {
  realName: undefined,
  photo: undefined,
  birthday: undefined,
  gender: undefined,
  nation: undefined,
  idType: undefined,
  idTypeOther: undefined,
  idNumber: undefined,
  idValidityType: undefined,
  idValidity: undefined,
  paymentLevel: undefined,
  joinType: undefined,
  company: undefined,
  job: undefined,
  phone: undefined,
  email: undefined,
  // identity: undefined,
  // profile: undefined,
  // vaccinated: undefined,
  // vaccinatedCert: undefined,
  // reason: undefined
};

export default {
  name: "personInfo",
  props: ['formDisabled'],
  data() {
    return {
      star: require("@/assets/img/asterisk.svg"),
      form: {},
      zhResume: "",
      enResume: "",
      basicInfo: [
        {
          label: "form.label.fullName",
          key: "realName",
          rule: true,
          arrowIcon: "",
          placeholder: "form.label.enter",
        },
        {
          label: "form.label.documentType",
          icon: "",
          key: "idType",
          rule: true,
          arrowIcon: "arrow",
          type: "sel",
          placeholder: "form.label.choice",
        },
        {
          label: "form.label.documentNum",
          icon: "",
          key: "idNumber",
          rule: true,
          arrowIcon: "",
          placeholder: "form.label.enter",
        },
        // {
        //   label: "form.label.documentVal",
        //   icon: "",
        //   key: "idValidityType",
        //   rule: true,
        //   arrowIcon: "arrow",
        //   type: "sel",
        //   placeholder: "form.label.choice",
        // },
      ],
      postInfo: [
        {
          label: "form.label.company",
          key: "company",
          rule: true,
          arrowIcon: "",
          placeholder: "form.label.enter",
          type: 'textarea',
          maxlength: 200
        },
        {
          label: "form.label.post",
          key: "job",
          rule: true,
          arrowIcon: "",
          placeholder: "form.label.enter",
          type: 'textarea',
          maxlength: 200
        },
        // {label: 'form.label.Participants',key: 'identity', rule: true, type: 'sel', arrowIcon: 'arrow', placeholder: 'form.label.choice'},
      ],
      rules: {
        realName: [{ msg: ["姓名不能为空", "Full Name is required."] }],
        photo: [{ msg: ["请上传照片", "Please upload Photo."] }],
        idType: [{ msg: ["请选择证件类型", "Please select ID Type."] }],
        idNumber: [{ msg: ["证件号不能为空", "ID Number is required."] }],
        company: [{ msg: ["单位不能为空", "Agency is required."] }],
        job: [{ msg: ["职务不能为空", "Working as is required."] }],
        phone: [
          { msg: ['手机号不能为空', 'Cell Number is required.'] },
          { regex: /^1[3-9][0-9]{9}$/, msg: ['手机号格式有误', 'Cell Number is not in the required format.'] }
        ],
        email: [
          { msg: ['邮箱不能为空', 'E-mail is required.'] },
          { regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/, msg: ['邮箱格式有误', 'E-mail is not in the required format.'] }
        ]
      },
      photo: false,
      uploader: [{ url: "https://img01.yzcdn.cn/vant/leaf.jpg" }],
      vaccinesVal: "是",
      showPicker: false,
      showTimePicker: false,
      showVaccinesPicker: false,
      formIdx: 0,
      columns: [],
      gender: [
        this.$t3("男", "male"),
        this.$t3("女", "female"),
        // this.$t3("保密", "secrecy"),
      ],
      vaccinated: [2, 3, 4, 0],
      idValidityType: [1, 2],
      nation: [],
      idType: [],
      identity: [],
      paymentLevel: [],
      joinType: [
        1,
        // 2
      ],
      dict: {
        gender: {
          男: this.$t3("男", "male"),
          女: this.$t3("女", "female"),
          保密: this.$t3("保密", "secrecy"),
          male: this.$t3("男", "male"),
          female: this.$t3("女", "female"),
          secrecy: this.$t3("保密", "secrecy"),
        },
        vaccinated: {
          2: this.$t3("一针", "Primary Dose I"),
          3: this.$t3("两针", "Primary Dose II"),
          4: this.$t3("加强针", "Booster Dose"),
          0: this.$t3("未接种", "Unvaccinated"),
        },
        idValidityType: [
          "",
          this.$t3("有效期", "Valid until"),
          this.$t3("长期", "Permanent"),
        ],
        nation: {},
        idType: {},
        identity: {},
        paymentLevel: {},
        joinType: {
          1: this.$t3('线上', 'online'),
          // 2: this.$t3('线下', 'offline')
        }
      },
      fileList: {
        photo: [],
        pressCard: [],
        vaccinatedCert: [],
      },
      uploadLoading: false,
      vaccinatedCertList: [],
      nowKey: "",
      currentDate: new Date(),
      minDate: new Date(new Date().getTime() - 100 * 365 * 86400 * 1000),
      maxDate: new Date(new Date().getTime() + 100 * 365 * 86400 * 1000),
    };
  },
  computed: {
    ...mapGetters(["needUpdateInfo", "status"]),
  },
  mounted() {
    this.getDictSelArr();
  },
  methods: {
    initForm(form) {
      this.form = Object.assign({}, tmpForm);
      objectMergLeft(this.form, form);
      if (this.form.photo && this.form.photo !== "") {
        this.fileList.photo = [
          {
            url: toMedia(this.form.photo),
            isImage: true,
          },
        ];
      }
      if (this.form.vaccinatedCert && this.form.vaccinatedCert !== "") {
        this.fileList.vaccinatedCert = [];
        this.vaccinationImageList = [];
        this.form.vaccinatedCert.split("|").forEach((x) => {
          this.fileList.vaccinatedCert.push({
            url: toMedia(x),
            isImage: true,
          });
          this.vaccinatedCertList.push(x);
        });
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (this.uploadLoading) {
          this.$notify(
            this.$t3(
              "有图片上传中，请稍后再试",
              "Please wait for the picture being uploaded."
            )
          );
          reject();
          return;
        }
        // 如果证件类型是其他，则需要设置证件类型名称
        if (
          this.dict.idType[this.form.idType] === "其他" ||
          this.dict.idType[this.form.idType] === "Other"
        ) {
          if (!this.form.idTypeOther) {
            this.$notify(this.$t3("证件类型不能为空", "ID Type is required."));
            reject();
            return;
          }
        }
        // 如果证件类型是身份证，则需要判断位数是否是18位
        if (
          this.dict.idType[this.form.idType] === "身份证" ||
          this.dict.idType[this.form.idType] === "身份证号" ||
          this.dict.idType[this.form.idType] === "ID Card" ||
          this.dict.idType[this.form.idType] === "identity card"
        ) {
          if (this.form.idNumber && this.form.idNumber.length != 18) {
            this.$notify(
              this.$t3(
                "证件号码格式有误",
                "ID number is not in the required format."
              )
            );
            reject();
            return;
          }
        }
        // 如果证件有效期类型不是长期，则需要设置证件有效期
        // if (!this.form.idValidityType) {
        //   this.$notify(
        //     this.$t3("请选择证件有效期", "Please select Date of Expiry")
        //   );
        //   reject();
        //   return;
        // }
        // if (this.form.idValidityType == 1) {
        //   if (!this.form.idValidity) {
        //     this.$notify(
        //       this.$t3("请选择证件有效期", "Please select Date of Expiry")
        //     );
        //     reject();
        //     return;
        //   }
        // }
        this.$validateI18n(this.form, this.rules).then(
          (res) => {
            if (res) {
              // // 如果选择接种疫苗，则判断是否上传疫苗照片
              // if (['1','2','3','4',1,2,3,4].indexOf(this.form.vaccinated) >= 0) {
              //   if (!this.form.vaccinatedCert) {
              //     this.$notify(this.$t3('请上传接种疫苗相关截图', 'Please upload your vaccination certificate'))
              //     reject();return
              //   }
              // } else {
              //   // 如果选择未接种疫苗，则判断是否填写未接种说明
              //   if (!this.form.reason) {
              //     this.$notify(this.$t3('未接种说明不能为空', 'Reason(s) for non-vaccination is required.'))
              //     reject();return
              //   }
              // }
              resolve(true);
            } else {
              reject();
            }
          },
          () => {
            reject();
          }
        );
      });
    },
    getDictSelArr() {
      getDictSelArr({
        conferenceId: this.$route.params.conferenceId,
        codes: "id_type",
      }).then((res) => {
        if (Object.hasOwnProperty.call(res.data, "id_type")) {
          this.idType = res.data.id_type.map((x) => x.code);
          this.dict.idType = getStatusObjTwo(
            this.$t3,
            res.data.id_type,
            "code",
            "name",
            "nameEn"
          );
        }
      });
    },
    // 上传照片
    uploadPhoto(params) {
      const file = params.file;
      this.uploadLoading = true;
      addFile({
        conferenceId: this.$route.params.conferenceId,
        file: file,
      }).then(
        (response) => {
          if (response.code && response.code === 200) {
            this.form.photo = response.data;
          } else {
            this.fileList.photo.pop();
          }
          this.uploadLoading = false;
        },
        () => {
          this.uploadLoading = false;
          this.fileList.photo.pop();
        }
      );
    },
    deletePhoto() {
      this.form.photo = "";
    },
    // 上传核酸证明
    afterRead(params) {
      const file = params.file;
      this.uploadLoading = true;
      addFile({
        conferenceId: this.$route.params.conferenceId,
        file: file,
      }).then(
        (response) => {
          if (response.code && response.code === 200) {
            this.vaccinatedCertList.push(response.data);
            this.form.vaccinatedCert = this.vaccinatedCertList.join("|");
          } else {
            this.fileList.vaccinatedCert.pop();
          }
          this.uploadLoading = false;
        },
        () => {
          this.uploadLoading = false;
          this.fileList.vaccinatedCert.pop();
        }
      );
    },
    deleteVaccination(params, indexParams) {
      const index = indexParams.index;
      this.vaccinatedCertList.splice(index, 1);
      this.form.vaccinatedCert = this.vaccinatedCertList.join("|");
    },
    photoCareful(label) {
      if (label === "form.label.photo") {
        this.photo = true;
      }
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    goNext() {
      this.$router.push("/staff/contact");
    },
    // 打开选择器
    openPop(key, idx, info) {
      this.formIdx = idx;
      this.nowKey = key;
      if (info === 0) {
        this.info = "基础";
      } else {
        this.info = "职务";
      }
      if (key === "birthday" || key === "idValidity") {
        this.currentDate = this.form[this.nowKey]
          ? new Date(this.form[this.nowKey].replace(/-/g, "/"))
          : new Date();
        this.showTimePicker = true;
      } else {
        this.columns = this[key];
        this.showPicker = true;
      }
    },
    // 关闭选择器
    onConfirm(value) {
      if (this.nowKey === "gender") {
        this.form[this.nowKey] = {
          男: "男",
          女: "女",
          保密: "保密",
          male: "男",
          female: "女",
          secrecy: "保密",
        }[value];
      } else {
        this.form[this.nowKey] = value;
      }
      this.showPicker = false;
    },
    onTimeConfirm(date) {
      this.form[this.nowKey] =
        date.getFullYear() +
        "-" +
        `${fixedNumber(date.getMonth() + 1)}-${fixedNumber(date.getDate())}`;
      this.showTimePicker = false;
    },
    onVaccines(value) {
      this.form.vaccinated = value;
      this.showVaccinesPicker = false;
    },
  },
};
</script>
